import { MaxButton } from 'pages/Pool/styleds'
import { Text } from 'rebass'
import styled from 'styled-components/macro'

export const Wrapper = styled.div`
  position: relative;
  padding: 20px;
  min-width: 460px;

  ${({ theme }) => theme.deprecated_mediaWidth.deprecated_upToExtraSmall`
    min-width: 340px;
  `};
`

export const SmallMaxButton = styled(MaxButton)`
  font-size: 12px;
  color: ${({ theme }) => theme.purple};
  border-color: ${({ theme }) => theme.purple};
  ${({ theme }) => !theme.darkMode && `background-color: #FBE8FE;`};
  :hover {
    border: 1px solid ${({ theme }) => theme.purple};
  }
  :focus {
    border: 1px solid ${({ theme }) => theme.purple};
    outline: none;
  }
`

export const ResponsiveHeaderText = styled(Text)`
  font-size: 40px;
  font-weight: 500;
  ${({ theme }) => theme.deprecated_mediaWidth.deprecated_upToExtraSmall`
     font-size: 24px
  `};
`
